__turbopack_context__.v({
  "DoubleCard": "ContentGroup-module-scss-module__YT1c3a__DoubleCard",
  "DoubleCardPadded": "ContentGroup-module-scss-module__YT1c3a__DoubleCardPadded",
  "DoubleCardWide": "ContentGroup-module-scss-module__YT1c3a__DoubleCardWide",
  "FourColumnScroll": "ContentGroup-module-scss-module__YT1c3a__FourColumnScroll",
  "SliderCards": "ContentGroup-module-scss-module__YT1c3a__SliderCards",
  "ThreeColumnScroll": "ContentGroup-module-scss-module__YT1c3a__ThreeColumnScroll",
  "ThreeColumnStack": "ContentGroup-module-scss-module__YT1c3a__ThreeColumnStack",
  "columns-2": "ContentGroup-module-scss-module__YT1c3a__columns-2",
  "columns-3": "ContentGroup-module-scss-module__YT1c3a__columns-3",
  "columns-4": "ContentGroup-module-scss-module__YT1c3a__columns-4",
  "container": "ContentGroup-module-scss-module__YT1c3a__container",
  "header": "ContentGroup-module-scss-module__YT1c3a__header",
  "headerText": "ContentGroup-module-scss-module__YT1c3a__headerText",
  "heading": "ContentGroup-module-scss-module__YT1c3a__heading",
  "item": "ContentGroup-module-scss-module__YT1c3a__item",
  "link": "ContentGroup-module-scss-module__YT1c3a__link",
  "section": "ContentGroup-module-scss-module__YT1c3a__section",
  "slider": "ContentGroup-module-scss-module__YT1c3a__slider",
  "subheading": "ContentGroup-module-scss-module__YT1c3a__subheading",
});
